/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SearchWikipediaPagesParams,
  WikipediaSearchResults
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Search Wikipedia pages
 */
export const searchWikipediaPages = (
    params: MaybeRefOrGetter<SearchWikipediaPagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<WikipediaSearchResults>(
      {url: `/wikipedia/pages/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchWikipediaPagesQueryKey = (params?: MaybeRefOrGetter<SearchWikipediaPagesParams>,) => {
    return [
    'wikipedia','pages','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchWikipediaPagesQueryOptions = <TData = Awaited<ReturnType<typeof searchWikipediaPages>>, TError = ErrorType<void>>(params: MaybeRefOrGetter<SearchWikipediaPagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWikipediaPages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchWikipediaPagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchWikipediaPages>>> = ({ signal }) => searchWikipediaPages(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchWikipediaPages>>, TError, TData>
}

export type SearchWikipediaPagesQueryResult = NonNullable<Awaited<ReturnType<typeof searchWikipediaPages>>>
export type SearchWikipediaPagesQueryError = ErrorType<void>


/**
 * @summary Search Wikipedia pages
 */

export function useSearchWikipediaPages<TData = Awaited<ReturnType<typeof searchWikipediaPages>>, TError = ErrorType<void>>(
 params: MaybeRefOrGetter<SearchWikipediaPagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWikipediaPages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchWikipediaPagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






